export default __webpack_public_path__ + "1d6367410baf743186ece609d8982787.svg";